import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";

export default function InvoiceHelpInfoModel(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Dialog
        className="user-filter-popup billinginfo-popup"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={props.open}
        aria-labelledby="responsive-dialog-title"
      >
        <Box sx={{ p: "22px 34px 0px 34px" }}>
          <Typography className="billing-info-title">
            1. Select a Customer
          </Typography>
          <Typography className="billing-info-text">
            First select a customer for which invoices will be viewed or
            created.
          </Typography>
          <Typography sx={{ mt: "30px" }} className="billing-info-title">
            2. Select a Project
          </Typography>
          <Typography className="billing-info-text">
            Once you select a customer, all projects assigned to that customer
            will appear in the 'Select a Project' drop down list. Select a
            project and a list of billing periods will appear below.
          </Typography>
          <Typography sx={{ mt: "30px" }} className="billing-info-title">
            3. Select a Billing Period
          </Typography>
          <Typography className="billing-info-text">
            All billing periods will appear in this list. To create an invoice
            simply select a period and click 'Create Invoice'. If the period has
            billing statements created by brokers, then you will be able to
            import that data after you select the period. If one or more broker
            has a billing statement created for a billing period then that
            billing period will be marked with the status of those billing
            statements. For example, if two brokers have a total of three
            billing statements in a single billing period and only one of those
            statements are closed then the period will be listed appended with
            the suffix '(2 pending)'.
          </Typography>
          <Typography sx={{ mt: "30px" }} className="billing-info-title">
            Billing period not eligible for invoicing.
          </Typography>
          <Typography className="billing-info-text">
            Billing period still has open statements and is therefore not yet
            eligible for invoicing. View the list of billing statements above
            and notify brokers with open statements that they are holding up
            invoicing.
          </Typography>
          <Typography sx={{ mt: "30px" }} className="billing-info-title">
            Filter:
          </Typography>
          <Typography className="billing-info-text">
            All billing periods between the start and stop dates of the selected
            filter will be displayed. You may also specify the status of billing
            statements you want to appear in the list. For example, if you only
            want to see which billing periods are ready for invoicing then you
            can select the 'Only ready to invoice' status filter.
          </Typography>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "22px 34px", pt: "20px" }}
        >
          <Button
            sx={{ color: "#212121 !important" }}
            className="cancel-btn"
            onClick={() => {
              props.setInvoiceHelp(false);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
